var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "choose-plan py-5", attrs: { id: "choose-plan" } },
    [
      _c("section-indicators", { attrs: { anchor: "choose-plan" } }),
      _vm._v(" "),
      _c("div", { staticClass: "container pt-3" }, [
        _c(
          "div",
          { staticClass: "choose-plan--header d-flex flex-column text-center" },
          [
            _c("div", { staticClass: "designation" }, [
              _c("h2", { staticClass: "text-lowercase mx-auto mb-2 mb-md-0" }, [
                _vm._v(_vm._s(_vm.headerInformation.title))
              ]),
              _vm._v(" "),
              _c("h4", { staticClass: "mx-auto" }, [
                _vm._v(_vm._s(_vm.headerInformation.subtitle))
              ])
            ]),
            _vm._v(" "),
            _vm.headerInformation.membershipGroupSelectorActive
              ? _c(
                  "div",
                  { staticClass: "period-options mt-5" },
                  [
                    _c("h5", { staticClass: "mb-4 period-options--title" }, [
                      _vm._v(
                        "\n                    Grupo de adesão:\n                    "
                      ),
                      _c("i", {
                        staticClass: "far fa-question-circle ml-2",
                        attrs: {
                          title: _vm.headerInformation.tooltip,
                          "data-placement": "bottom",
                          "data-toggle": "tooltip"
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("choose-order-group", {
                      attrs: { group: _vm.orderGroup },
                      model: {
                        value: _vm.orderGroup,
                        callback: function($$v) {
                          _vm.orderGroup = $$v
                        },
                        expression: "orderGroup"
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.orderGroup === "one",
                expression: "orderGroup === 'one'"
              }
            ],
            staticClass: "row choose-plan--body mt-5 justify-content-center"
          },
          _vm._l(_vm.groupOne, function(boxOne, index) {
            return _c("plan-school-card", {
              key: index,
              staticClass: "col-12 col-md-6 col-lg-3 mb-3 mb-md-0 px-lg-2",
              attrs: {
                "card-number": Number.parseInt(index.substr(-1, 1)) - 1,
                "plan-display": boxOne
              }
            })
          }),
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.orderGroup === "two",
                expression: "orderGroup === 'two'"
              }
            ],
            staticClass: "row choose-plan--body mt-5 justify-content-center"
          },
          _vm._l(_vm.groupTwo, function(boxTwo, index) {
            return _c("plan-school-card", {
              key: index,
              staticClass: "col-12 col-md-6 col-lg-3 mb-3 mb-md-0 px-lg-2",
              attrs: {
                "card-number": Number.parseInt(index.substr(-1, 1)) - 1,
                "plan-display": boxTwo
              }
            })
          }),
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.orderGroup === "three",
                expression: "orderGroup === 'three'"
              }
            ],
            staticClass: "row choose-plan--body mt-5 justify-content-center"
          },
          _vm._l(_vm.groupThree, function(boxThree, index) {
            return _c("plan-school-card", {
              key: index,
              staticClass: "col-12 col-md-6 col-lg-3 mb-3 mb-md-0 px-lg-2",
              attrs: {
                "card-number": Number.parseInt(index.substr(-1, 1)) - 1,
                "plan-display": boxThree
              }
            })
          }),
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/simon/code/ataba-wordpress-site/web/app/themes/rits/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/simon/code/ataba-wordpress-site/web/app/themes/rits/node_modules/vue-loader/lib?{}!./scripts/vue/template-school/ChoosePlanSchool.vue?vue&type=template&id=88436de0&
// module id = 441
// module chunks = 1